<template>
	<div class="categories wrap">	
		<card-product-big 
			class="margin-bottom"
			:product="product"
			v-for="product in products"
			:key="product.id"
		/>
	</div>
</template>

<script>
import cardProductBig from '@/components/cardProductBig';

function data() {
	return {
		productsCategory: [],
	};
}

export default {
	name: 'products-categories',
	components: {
		cardProductBig,
	},
	data,
	props: {
		products: {
			type: Array,
			default: () => [],
		},
	},
};
</script>


<style lang="scss" scoped>

.categories {
	display: grid;
	grid-gap: 1rem;
	grid-template-columns: repeat(auto-fill, minmax(18rem, 1fr));
}

@media screen and (max-width: 645px) {
	.categories {
		display: block;
	}
}

.margin-bottom {
	margin: 1rem;
}

</style>



// WEBPACK FOOTER //
// productsCategories.vue?3def15fe